// Pure display/derivation helpers for per-admin station & contractor-type
// scope (see migration 0059: NULL/empty = unrestricted).

export function listSummary(values: string[] | null, noun: string): string {
  if (!values || values.length === 0) return `All ${noun}`;
  if (values.length === 1) return values[0]!;
  return `${values.length} ${noun}`;
}

export function accessSummary(stations: string[] | null, types: string[] | null): string {
  return `${listSummary(stations, 'stations')} · ${listSummary(types, 'types')}`;
}

// The stations a user can pick as "active": their assignment, or every
// configured station when unrestricted.
export function visibleStations(assigned: string[] | null, configured: string[]): string[] {
  return assigned && assigned.length > 0 ? assigned : configured;
}

// Sidebar caption under the user's email: the active station if narrowed,
// otherwise the assignment summary ("All stations", "2 stations", …).
export function scopeSummaryLabel(assigned: string[] | null, activeStation: string | null): string {
  if (activeStation) return activeStation;
  return listSummary(assigned, 'stations');
}

// Assignment-editor options: configured list plus any already-assigned values
// no longer configured, so a revoked option remains visible and removable.
export function mergedOptions(configured: string[], assigned: string[] | null): string[] {
  const extra = (assigned ?? []).filter((v) => !configured.includes(v));
  return [...configured, ...extra];
}
